export default "__VITE_ASSET__DmoduDJf__"